import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ComponentBase, RentalObjectInfo, RequestDetails, DeviceType } from 't4core';
import { ObjectDialog } from '../../dialogs/ObjectDialog/ObjectDialog';
import { CreateServiceRequestDialog } from '../../dialogs/createServiceRequestDialog/createServiceRequestDialog';


@Component({
    selector: 't4-object-link',
    templateUrl: './objectLink.html',
    styleUrls: ['./objectLink.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class T4ObjectLink extends ComponentBase implements AfterViewInit {
    public gpsLockId: string;
    public hasNfcTag: boolean = false;
    private _objectId: number;
    @Input() public displayText: string;
    @Input() public set objectId(value: number) {
        if (!value) return;

        var val = parseInt(value.toString());
        if (this._objectId != val) {
            this._objectId = val;
        }
    };
    @Input() public set object(c: RentalObjectInfo) {
        if (c) {
            this.displayText = c.Title;
            this._objectId = c.Id;
        }

        this._object = c;
    };
    public _object: RentalObjectInfo;
    public get object(): RentalObjectInfo { return this._object; }
    public get objectId(): number { return this._objectId; }

    @ViewChild("ref", {static: true}) public content: ElementRef;
    @ViewChild("menuTrigger", { static: true}) public menuTrigger: MatMenuTrigger;

    @Output() public mouseOver = new EventEmitter<RentalObjectInfo>();
    @Output() public mouseOut = new EventEmitter<RentalObjectInfo>();
    @Output() public dataChange = new EventEmitter<RentalObjectInfo>();

    public isLoading: boolean = false;
    public _opening: boolean = false;

    public requests: RequestDetails[] = [];

    constructor(public ChangeDetector: ChangeDetectorRef) {
        super();
    }

    public ngAfterViewInit() {
        if (!this.displayText) {
            this.loadObject();
        }

        this.ChangeDetector.detectChanges();
    }

  // ## Data methods

  private async loadObject() {
    this.isLoading = true;
    this._opening = false;

    this._object = await this.Api.get<RentalObjectInfo>("RentalObject/GetObjectInfo", { objectId: this._objectId });

    if (this._object) {
      if (!this.displayText) {
        this.displayText = this._object.Title;
      }

      if (this._object.Locks) {
        const gpsLock = this._object.Locks.find(x => x.DeviceType == DeviceType.NfcTag);
        this.hasNfcTag = !!gpsLock;
        if (gpsLock) {
          this.gpsLockId = gpsLock.Id;
        }
      } else {
        this.hasNfcTag = false;
      }

      this.isLoading = false;
      this.mouseOver.emit(this._object);
      this.ChangeDetector.detectChanges();
    }
  }

    // ## Data methods
    public show() {
        if (!this._object) {
            if (this._opening) return;

            this._opening = true;
            setTimeout(() => {
                if (this._opening) this.loadObject();
            }, 200);
        } else {
            this.mouseOver.emit(this._object);
        }
    }

    public hide() {
        this._opening = false;
        this.mouseOut.emit(this._object);
    }

    public async open() {
        if (!this._object) return;

        this.mouseOut.emit(this._object);

      var x = await ObjectDialog.open(this.Dialog, this._object, this._objectId);
      if (x) {
        this.loadObject();
      }
      this.dataChange.emit(this._object);
    }

    public onRightClick() {
        this.menuTrigger.openMenu();
    }

    public async registerIssue() {
        var x = await CreateServiceRequestDialog.open(this.Dialog, this._objectId, null, this.object);

        this.dataChange.emit(this._object);
    }
}
